import React, { FC } from 'react'
import DynamicSVG from '../../atoms/DynamicSvg/DynamicSvg'
import { getImage } from '../../../app/utlis/imageConstants'

interface ReliabilityERPSoftwareProps {
    erpSoftwareData: any
}

const ReliabilityERPSoftware: FC<ReliabilityERPSoftwareProps> = ({ erpSoftwareData }) => {
    return (
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 p-4 sm:p-8 lg:p-16 lg:px-36'>
            {erpSoftwareData.ReliabilityERPSoftwareData.map((reliable: any, idx: any) => {
                 let img = getImage(reliable.image ?? "") ?? "";
                return (
                    <div className='bg-blackDarkThemeSecondary rounded-3xl' key={idx}>
                        <div
                         className='bg-blackDarkThemeSecondary flex flex-col items-start justify-center p-4 sm:p-6 relative overflow-hidden gap-2 rounded-3xl'>
                            <div className={`w-12 h-12 sm:w-16 sm:h-16 rounded-xl p-2 ${idx === 0 ? 'bg-yellow' : 'bg-darkGreyPrimary'} text-black flex items-center justify-center font-bold text-2xl`}>
                                {/* <img src={reliable.image} className='w-6 h-6 sm:w-8 sm:h-8' alt={reliable.title} /> */}
                                <DynamicSVG size='w-6 h-6 sm:w-8 sm:h-8'>{img}</DynamicSVG>
                            </div>
                            <div className={`text-lg sm:text-xl text-start font-semibold mb-1 text-white`}>{reliable.title}</div>
                            <div className='text-lightGrey text-xs sm:text-sm'>{reliable.subtitle}</div>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default ReliabilityERPSoftware
